module.exports = __webpack_public_path__ + "static/img/so1_4.3685564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so1_4.jpg
// module id = fWRt
// module chunks = 11